/* eslint-disable no-case-declarations */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import metadata from './MLPUPExcludedWatercraftsComponent.metadata.json5';
import './MLPUPExcludedWatercraftsComponent.messages';

// Component is only shown in read only
function MLPUPExcludedWatercraftsComponent(props) {
    const {
        items,
        getTypeKeyDescription,
        getYesNoAnswer
    } = props;

    const viewModelService = useContext(ViewModelServiceContext);
    const watercraftTypeTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('PUPWatercraftType_PUE');

    const generateItemOverrides = () => {
        const itemOverrides = items.map((item, itemIndex) => {
            return {
                [`excludedContent${itemIndex}`]: {
                    content: getYesNoAnswer(item.isExcluded)
                },
                [`typeContent${itemIndex}`]: {
                    content: getTypeKeyDescription(watercraftTypeTypelist.getCode(item.watercraftType).name)
                }
            };
        });

        return Object.assign({}, ...itemOverrides);
    };

    const overrides = {
        tableRowIterable: {
            data: items
        },
        ...generateItemOverrides()
    };
    const resolvers = {};

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

MLPUPExcludedWatercraftsComponent.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    getTypeKeyDescription: PropTypes.func.isRequired,
    getYesNoAnswer: PropTypes.func.isRequired
};

export default MLPUPExcludedWatercraftsComponent;
